package br.com.heyagenda.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class SavedClient(
    val id: String = "",
    val name: String,
    val phone: String? = null,
    val totalAppointments: Int = 1,
    val lastAppointmentDate: String? = null,
    val lastServiceName: String? = null,
    val notes: String? = null
)
